export const showNoDataText = (tab: number) => {
  switch (tab) {
    case 1:
      return '尚無收件紀錄';
    case 2:
      return '尚無已完成紀錄';
    default:
      return '尚無寄件紀錄';
  }
};
